import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Components */
import { Icon, Avatar } from "../../components"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* REST API */
import { get } from "../../api/Transaction"

/* Widgets */
import { toast } from "../common"

/* Shared */
import { kindOf, statusOf, PLANS, CERTIFICATE_STATES, cardOf } from "./shared"
import { SUBSCRIPTION_STATUSES, organizationIcon } from "../organization/shared"
import { ago, initialsOf, avatarColorOf } from "../user/shared"
import { plural } from "../category/shared"
import { money } from "../service/shared"

/* Constants */
import { env } from "../../constants"

/* Moment */
import moment from "moment"

Modal.setAppElement("#root")


/* Widget Transaction Modal — one payment with everything around it: for a point — its subscription,
   the card and the whole history of its payments; for a gift certificate — who bought it, for whom
   and what is left of it. It is opened by the reference: this._transaction.current.open(item).
   Props: onOrganization(id), onClient(user) — both optional */
class TransactionModal extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "loading",
            data: null,
            item: null
        }
    }

    open = item => {
        this.setState({ visible: true, item, status: "loading", data: null }, () => this.load())
    }

    close = () => {
        this.setState({ visible: false })
    }

    load = () => {

        const { item } = this.state

        get({ source: item.source, id: item.id }).then(response => {
            if (response && response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else {
                this.setState({ status: "error" })
            }
        }).catch(() => this.setState({ status: "error" }))
    }

    copy = text => {

        if (!navigator.clipboard || !text) {
            return
        }

        navigator.clipboard.writeText(text).then(() => toast.success("Скопировано")).catch(() => { })
    }

    /* Another card opens — this one closes first */
    go = (handler, value) => {

        if (!handler) {
            return
        }

        this.setState({ visible: false })
        handler(value)
    }

    /* The top — the sum, the state and the two references of the gateway */
    _hero = () => {

        /* Fields */
        const { item, data } = this.state

        const transaction = data ? data.transaction : item
        const kind = kindOf(transaction.kind)
        const status = statusOf(transaction.status)

        return (
            <div className={`transaction-hero ${transaction.status}`}>

                <div className="transaction-hero-top">
                    <div className={`transaction-icon ${kind.accent}`}><Icon name={kind.icon} size={22} width={1.9} /></div>
                    <div className="transaction-hero-badges">
                        <div className={`user-badge ${status.accent}`}><Icon name={status.icon} size={11} width={2.6} />{status.text}</div>
                        <div className="user-badge grey" title={kind.hint}>{kind.text}</div>
                    </div>
                </div>

                <div className="transaction-hero-amount">{money(transaction.amount)}</div>
                <div className="transaction-hero-date">{moment(transaction.date).format("D MMMM YYYY, HH:mm")} · {ago(transaction.date)}</div>

                <div className="transaction-references">
                    {[{ text: "Заказ", value: transaction.orderId }, { text: "Транзакция шлюза", value: transaction.paymentId }].map(reference =>
                        <div key={reference.text} onClick={() => this.copy(reference.value)} className={`transaction-reference ${reference.value ? "" : "empty"}`} title={reference.value ? "Скопировать" : ""}>
                            <span>{reference.text}</span>
                            <b>{reference.value ? reference.value : "—"}</b>
                            {reference.value && <Icon name="layers" size={13} width={2} />}
                        </div>
                    )}
                </div>

            </div>
        )
    }

    /* A payment of a point */
    _subscription = () => {

        /* Fields */
        const { data } = this.state
        const { onOrganization } = this.props

        const { organization, subscription, card, owner, history, totals } = data

        return (
            <>
                {organization &&
                    <div className="user-section">

                        <div className="user-section-title">Точка</div>

                        <div onClick={() => this.go(onOrganization, organization.id)} className={`master-team ${onOrganization ? "link" : ""}`}>
                            <Avatar className="user-point-avatar" src={organization.image ? `${env.mediapoint}organizations/${organization.image}` : null} alt={organization.name}>
                                {organizationIcon()}
                            </Avatar>
                            <div className="master-team-text">
                                <div className="master-team-name"><b>{organization.name}</b>{parseInt(organization.visible) === 0 && <em>Отключена</em>}</div>
                                <div className="master-team-meta">
                                    {organization.city && <span>{organization.city}</span>}
                                    {organization.phone && <span>{organization.phone}</span>}
                                    {organization.subscribedUntil && <span>оплачено до {moment(organization.subscribedUntil).format("D MMM YYYY")}</span>}
                                </div>
                            </div>
                            {onOrganization && <div className="master-team-arrow"><Icon name="right" size={14} width={2} /></div>}
                        </div>

                    </div>
                }

                <div className="user-section">

                    <div className="user-section-title">Подписка</div>

                    <div className="transaction-facts">
                        <div><span>Тариф</span><b>{subscription ? `${PLANS[subscription.plan] ? PLANS[subscription.plan] : subscription.plan} · ${money(subscription.amount)}` : "—"}</b></div>
                        <div><span>Статус</span><b>{subscription && SUBSCRIPTION_STATUSES[subscription.status] ? SUBSCRIPTION_STATUSES[subscription.status].text : (subscription ? subscription.status : "—")}</b></div>
                        <div><span>Срок до</span><b>{subscription && subscription.currentPeriodEnd ? moment(subscription.currentPeriodEnd).format("D MMMM YYYY") : "—"}</b></div>
                        <div><span>Автопродление</span><b>{subscription ? (parseInt(subscription.autoRenew) === 1 && !subscription.cancelAt ? "Включено" : "Выключено") : "—"}</b></div>
                        <div><span>Карта</span><b>{card && cardOf(card.cardPan) ? `${cardOf(card.cardPan)}${card.member ? ` · ${card.member}` : ""}` : "—"}</b></div>
                        <div><span>Владелец</span><b>{owner ? `${owner.name ? owner.name : "Без имени"}${owner.phone ? ` · ${owner.phone}` : ""}` : "—"}</b></div>
                    </div>

                </div>

                {totals && history.length > 0 &&
                    <div className="user-section">

                        <div className="user-section-title">
                            Все оплаты точки
                            <span>{money(totals.paid)} за {totals.payments} {plural(totals.payments, "платёж", "платежа", "платежей")}{totals.firstPaid ? ` · с ${moment(totals.firstPaid).format("MMM YYYY")}` : ""}</span>
                        </div>

                        <div className="transaction-history">
                            {history.map(row => {

                                const kind = kindOf(row.kind)
                                const status = statusOf(row.status)

                                return (
                                    <div key={`${row.id}`} className={`transaction-history-row ${row.status} ${row.current ? "current" : ""}`}>
                                        <div className={`transaction-dot ${kind.accent}`}><Icon name={kind.icon} size={12} width={2.2} /></div>
                                        <div className="transaction-history-text">
                                            <b>{kind.text}</b>
                                            <span>{moment(row.date).format("D MMM YYYY, HH:mm")}{row.status !== "success" ? ` · ${status.text.toLowerCase()}` : ""}</span>
                                        </div>
                                        <div className="transaction-history-amount">{money(row.amount)}</div>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                }
            </>
        )
    }

    /* A person of a certificate — clickable when the client has an account */
    _person = (title, user, fallbackName, fallbackPhone) => {

        /* Fields */
        const { onClient } = this.props

        const name = user && user.name ? user.name : fallbackName
        const phone = user && user.phone ? user.phone : fallbackPhone
        const link = user && onClient

        return (
            <div onClick={() => link && this.go(onClient, user)} className={`transaction-person ${link ? "link" : ""}`}>
                <div className="transaction-person-avatar" style={{ background: avatarColorOf(user ? user.id : 0) }}>
                    {name ? initialsOf(name) : <Icon name="user" size={16} width={2} />}
                </div>
                <div className="transaction-person-text">
                    <span>{title}</span>
                    <b>{name ? name : "Без имени"}</b>
                    {phone && <em>{phone}</em>}
                </div>
                {link && <Icon name="right" size={14} width={2} />}
            </div>
        )
    }

    /* A gift certificate */
    _certificate = () => {

        /* Fields */
        const { data } = this.state

        const { certificate, buyer, recipient, usedBy } = data
        const state = CERTIFICATE_STATES[certificate.status] ? CERTIFICATE_STATES[certificate.status] : { text: certificate.status, accent: "grey" }
        const balance = certificate.balance !== null && certificate.balance !== undefined ? parseInt(certificate.balance) : parseInt(certificate.amount)
        const spent = parseInt(certificate.amount) - balance

        return (
            <>
                <div className="user-section">

                    <div className="transaction-gift">

                        <div className="transaction-gift-top">
                            <div>
                                <span>Код сертификата</span>
                                <b onClick={() => this.copy(certificate.code)} title="Скопировать">{certificate.code ? certificate.code : "—"}</b>
                            </div>
                            <div className={`user-badge ${state.accent}`}><i />{state.text}</div>
                        </div>

                        <div className="transaction-gift-balance">
                            <div className="transaction-gift-bar"><i style={{ width: `${certificate.amount > 0 ? balance / certificate.amount * 100 : 0}%` }} /></div>
                            <div className="transaction-gift-numbers">
                                <span>Остаток <b>{money(balance)}</b></span>
                                <span>{spent > 0 ? `потрачено ${money(spent)}` : "не тратился"}</span>
                            </div>
                        </div>

                        {certificate.message && <p>«{certificate.message}»</p>}

                    </div>

                </div>

                <div className="user-section">

                    <div className="user-section-title">Кто и кому</div>

                    <div className="transaction-people">
                        {this._person("Покупатель", buyer, certificate.sender, null)}
                        {this._person("Получатель", recipient, certificate.recipient, certificate.phone)}
                        {usedBy && this._person(`Использовал ${certificate.usedAt ? moment(certificate.usedAt).format("D MMM YYYY") : ""}`, usedBy, null, null)}
                    </div>

                    <div className="transaction-facts">
                        <div><span>Доставка</span><b>{certificate.delivery === "whatsapp" ? "WhatsApp" : (certificate.delivery ? certificate.delivery : "—")}{certificate.sendAt ? ` · ${certificate.sendAt}` : ""}</b></div>
                        <div><span>Действует до</span><b>{certificate.expiresAt ? moment(certificate.expiresAt).format("D MMMM YYYY") : "—"}</b></div>
                    </div>

                </div>
            </>
        )
    }

    _body = () => {

        /* Fields */
        const { status, data } = this.state

        if (status === "loading") {
            return <div className="wide-modal-loading"><LoadingOutlined /></div>
        }

        if (status !== "ok") {
            return (
                <div className="wide-modal-loading">
                    <Icon name="alert" size={38} width={1.5} />
                    <p>Не удалось загрузить платёж</p>
                </div>
            )
        }

        if (data.certificate) {
            return this._certificate()
        }

        return this._subscription()
    }

    render = () => {

        /* Fields */
        const { visible, item } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="wide-modal large user-modal"
                overlayClassName="wide-modal-overlay"
                closeTimeoutMS={200}
            >

                <div className="wide-modal-header">
                    <h2>Платёж</h2>
                    <div onClick={this.close} className="wide-modal-close">
                        <Icon name="close" size={11} width={2.2} />
                    </div>
                </div>

                {item &&
                    <div className="wide-modal-body">
                        {this._hero()}
                        {this._body()}
                    </div>
                }

            </Modal>
        )
    }
}

export default TransactionModal
